export default __webpack_public_path__ + "static/media/1.e597c4c4.jpg";